export default __webpack_public_path__ + "static/media/misc-drawerA-2048w.cd2089cb.avif";